const sliderProducts = () => {
    const sections = document.querySelectorAll('.slider-products');
    if (!sections.length) return;

    sections.forEach(section => {
        const swiper = section.querySelector('.slider-products__swiper');
        if (!swiper) return;

        new Swiper(swiper, {
            slidesPerView: 1.2,
            spaceBetween: 16,
            loop: false,
            pagination: {
                el: section.querySelector('.slider-products__pagination'),
                clickable: true,
                type: 'fraction',
            },
            navigation: {
                prevEl: section.querySelector('.slider-products__btn-prev'),
                nextEl: section.querySelector('.slider-products__btn-next'),
            },
            breakpoints: {
                576: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                992: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                },
                1200: {
                    slidesPerView: 4,
                    spaceBetween: 24,
                },
            },
        });
    });
};

export default sliderProducts;
